import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import {
  TuiFormatPhonePipe,
  TuiTextfieldControllerModule,
  TuiTextareaModule,
  TuiInputModule,
  TuiInputNumberModule,
  TuiInputPasswordModule,
} from '@taiga-ui/legacy';
import { TuiEditor, TuiEditorSocket, TUI_EDITOR_DEFAULT_EXTENSIONS } from '@taiga-ui/editor';
import {
  TuiDataList,
  TuiLoader,
  TuiScrollbar,
  TuiScrollable,
  TuiGroup,
  TuiDropdown,
  TuiIcon,
  TuiButton,
  TuiHint,
  TuiAutoColorPipe,
  TuiInitialsPipe,
  TuiAppearance,
} from '@taiga-ui/core';
import { TuiAvatar, TuiBlock, TuiCheckbox } from '@taiga-ui/kit';
import { TuiActiveZone, TuiAutoFocus } from '@taiga-ui/cdk';
import { TUI_EDITOR_EXTENSIONS } from '@taiga-ui/editor';
import { NgxPermissionsModule } from 'ngx-permissions';
import { ListModule } from '@src/app/shared/list';
import { SharedModule } from '@src/app/shared';
import { MessageListModule } from '@src/app/modules/message-list';
import { MessageModule } from '@src/app/modules/message';
import { GroupInfoModule } from '@src/app/modules/group-info';
import { SearchGroupsModule } from '@src/app/shared/search-groups';
import { ComponentsModule } from '@src/app/components';
import { LogoModule } from '@src/app/modules/logo';
import { WaitTelegramChatsModule } from '@src/app/modules/wait-telegram-chats';
import { InputCodeModule } from '@src/app/modules/input-code';
import { IconModule } from '@src/app/modules/icon';
import { PhoneModule } from '@src/app/modules/phone';
import { DialogsModule } from '@src/app/shared/dialogs';
import { AttachmentModule } from '@src/app/modules/internal-messenger/attachment';
import { ActionsModule } from '@src/app/modules/actions';

import { CustomNamesTabsModule } from '../custom-name-tabs';

import { UserModule } from './ui/user';
import { GroupModule } from './ui/group';
import { MediaRecorderModule } from './ui/media-recorder';
import { PinnedMessageListModule } from './ui/pinned-message-list';
import { ForwardModule } from './ui/forward';
import { BotModule } from './ui/bot';
import { ChatsComponent } from './ui/chats/chats.component';
import { NewsFeedComponent } from './ui/news-feed/news-feed.component';
import { ChatComponent } from './ui/chat/chat.component';
import { FoldersComponent } from './ui/folders/folders.component';
import { LoginComponent } from './ui/login/login.component';
import { CheckAuthComponent } from './ui/check-auth/check-auth.component';
import { ConversationBoxInputComponent } from './ui/chat/components/conversation-box-input/conversation-box-input.component';
import { DialogConfirmLoginComponent } from './ui/dialog-confirm-login/dialog-confirm-login.component';
import { GroupInfoTelegramModule } from './ui/group-info-telegram';

@NgModule({
  declarations: [
    NewsFeedComponent,
    ChatComponent,
    ChatsComponent,
    FoldersComponent,
    LoginComponent,
    CheckAuthComponent,
    ConversationBoxInputComponent,
    DialogConfirmLoginComponent,
  ],
  imports: [
    CommonModule,
    TuiButton,
    ListModule,
    LogoModule,
    ForwardModule,
    TuiAvatar,
    SharedModule,
    TuiGroup,
    ...TuiDropdown,
    PinnedMessageListModule,
    MessageListModule,
    MessageModule,
    AttachmentModule,
    TuiTextareaModule,
    FormsModule,
    TuiTextfieldControllerModule,
    MediaRecorderModule,
    TuiScrollbar,
    TuiScrollable,
    UserModule,
    BotModule,
    GroupModule,
    TuiBlock,
    TuiCheckbox,
    ...TuiDataList,
    TuiIcon,
    TuiInputModule,
    GroupInfoModule,
    SearchGroupsModule,
    NgxPermissionsModule,
    RouterModule,
    TuiLoader,
    TuiInputNumberModule,
    TuiAutoFocus,
    TuiInputPasswordModule,
    ComponentsModule,
    WaitTelegramChatsModule,
    TuiFormatPhonePipe,
    InputCodeModule,
    IconModule,
    PhoneModule,
    TuiEditor,
    TuiEditorSocket,
    TuiActiveZone,
    CustomNamesTabsModule,
    DialogsModule,
    GroupInfoTelegramModule,
    ...TuiHint,
    ActionsModule,
    TuiAutoColorPipe,
    TuiInitialsPipe,
    TuiAppearance,
  ],
  providers: [
    {
      provide: TUI_EDITOR_EXTENSIONS,
      useValue: TUI_EDITOR_DEFAULT_EXTENSIONS,
    },
  ],
  exports: [LoginComponent, DialogConfirmLoginComponent],
})
export class TelegramModule {}
